export default [{
  path: 'operationLog',
  name: 'operationLog',
  component: () => import('./views/operationLog'),
  meta: {
    title: "操作日志"
  }
},
]
